(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["odd-halloween-campaign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-hw-copy]');
    if (!button) return;
    try {
      await navigator.clipboard.writeText('2026HALLOWEEN');
      button.textContent = button.dataset.copied;
    } catch {
      button.textContent = button.dataset.failed;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["odd-last-update"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const root = document.getElementById('odd-last-update');
      if (!root || root.dataset.paginationReady) return;
      const entries = [...root.querySelectorAll('.lu-entry')];
      const nav = root.querySelector('.lu-pagination');
      const status = root.querySelector('.lu-status');
      const pages = Math.ceil(entries.length / 6);
      if (pages < 2) return;
      root.dataset.paginationReady = 'true';
      const links = Array.from({ length: pages }, (_, i) => {
        const link = document.createElement('a');
        link.href = '#updates-page-' + (i + 1);
        link.textContent = String(i + 1);
        link.setAttribute('aria-label', 'Page ' + (i + 1));
        nav.append(link);
        return link;
      });
      const show = (page, focus = false) => {
        entries.forEach((entry, i) => { entry.hidden = i < (page - 1) * 6 || i >= page * 6; });
        links.forEach((link, i) => { if (i + 1 === page) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current'); });
        status.textContent = 'Articles ' + ((page - 1) * 6 + 1) + '–' + Math.min(page * 6, entries.length) + ' of ' + entries.length;
        if (focus) { root.focus({ preventScroll: true }); root.scrollIntoView({ behavior: 'instant', block: 'start' }); }
      };
      const fromHash = () => Math.min(pages, Math.max(1, Number(location.hash.match(/^#updates-page-(\d+)$/)?.[1]) || 1));
      nav.hidden = false;
      show(fromHash());
      nav.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        history.pushState(null, '', link.getAttribute('href'));
        show(links.indexOf(link) + 1, true);
      });
      window.addEventListener('popstate', () => show(fromHash()));
      window.addEventListener('hashchange', () => show(fromHash()));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
